// Gift history. Mirrors data-component="gift-history" from the approved
// HTML. Shows the sample empty state for a never-gifted customer.
//
// TODO(runtime): hydrate from
// dist/account-workflows.ensureAccountWorkflows().gifts (confirmed) for
// the customer. Order newest-first; a shipped gift becomes the eligibility
// anchor for the 90-day cadence rule.
import type { ReactNode } from 'react';
import { Icon } from '../../_shared/IconSprite.js';

export interface GiftHistoryItem {
  id: string;
  name: string;
  variant?: string;
  status: 'pending' | 'attached' | 'shipped' | 'held' | 'unknown' | 'failed';
  statusCopy: string;
  rep: string;
  date: string;
}

export interface GiftHistoryProps {
  items: GiftHistoryItem[];
}

export function GiftHistory({ items }: GiftHistoryProps): ReactNode {
  return (
    <section className="card" data-component="gift-history">
      <div className="section-heading">
        <h3>Gift history</h3>
        <span>Sarah's account</span>
      </div>
      {items.length === 0 ? (
        <div className="gift-empty">
          <span className="history-icon">
            <Icon id="box" />
          </span>
          <div>
            <strong>No previous gifts in this sample</strong>
            <p>
              Requested, attached and shipped gifts will appear here with their dates and
              responsible rep.
            </p>
          </div>
        </div>
      ) : (
        <ul className="gift-history-list">
          {items.map((item) => (
            <li key={item.id}>
              <strong>{item.name}</strong>
              {item.variant ? <small> · {item.variant}</small> : null}
              <p>{item.statusCopy}</p>
              <small>
                {item.date} · {item.rep}
              </small>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
